/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import router from '@/router';
import store from '@/store';
import VabProgress from 'nprogress';
import 'nprogress/nprogress.css';
import getPageTitle from '@/utils/pageTitle';
import { authentication, loginInterception, recordRoute, routesWhiteList } from '@/config';
import { asyncRoutes } from '@/router';
import { getAccessToken, removeAccessToken, setAccessToken, TokenKey } from '@/utils/accessToken';
import { Cookie } from '@/utils/storage';
VabProgress.configure({
  easing: 'ease',
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
});

const toLogin = (next, path) => {
  next({ path: '/login', replace: true });
};
router.beforeEach(async (to, from, next) => {
  if (to.meta.isnewWin == 1) {
    window.open(to.meta.newWinPath);
    return;
  }
  const { showProgressBar } = store.getters['settings/theme'];
  if (showProgressBar) VabProgress.start();
  let hasToken = Cookie.get(TokenKey);
  if (!loginInterception) hasToken = true;
  //如果isnewWin==1 打开新窗口
  //#region  自己添加的

  if (to.params.newTitle) {
    to.meta.title = to.params.newTitle;
    sessionStorage.setItem(to.name, to.params.newTitle);
  }
  if (sessionStorage.getItem(to.name)) {
    to.meta.title = sessionStorage.getItem(to.name);
  }
  //#endregion

  //【token】校验逻辑****************************************************************************************************
  //一.如果在白名单里面  且没有token
  if (routesWhiteList.includes(to.path)) {
    //如果没有不符合条件   回到登陆页面
    if (to.path === '/login' && hasToken) {
      let queryData = to.query;
      delete queryData.tp_token;
      next({ path: '/', query: queryData });
      // next({ path: '/' });
    } else {
      next();
    }
  } else {
    if (hasToken) {
      const userName = store.getters['user/username'];
      const userId = store.getters['user/userId'];
      let role = store.getters['acl/role'];

      if (userName && userId && userId != '') {
        next();
      } else {
        try {
          //如果从vuex里找不到人员信息，执行vuex里面的use.js中的getUserInfo方法，
          //获取用户信息数据（异步方法 用dispatch）
          await store.dispatch('user/getUserInfo');
          //获取用菜单数据
          let menu = store.getters['user/userMenu'];
          //根据路由模式获取路由并根据权限过滤
          await store.dispatch('routes/setRoutes', authentication);

          let okuserId = store.getters['user/userId'];
          let okuserrole = store.getters['acl/role'];

          next({ ...to, replace: true });
        } catch (err) {
          await store.dispatch('user/resetAll');
          toLogin(next, to.path);
        }
      }
    } else {
      toLogin(next, to.path);
    }
  }
});
router.afterEach((to) => {
  document.title = getPageTitle(to.meta.title);
  if (VabProgress.status) VabProgress.done();
});
